import React from 'react';
import { Card } from './ui/card';
import { Users } from 'lucide-react';

export const OnlineTeamMembers = ({ onlineUsers = [], connected }) => {
  const count = onlineUsers.length;

  return (
    <Card className="p-4 border border-[#E2E8F0]" data-testid="online-team-members">
      <div className="flex items-center gap-3">
        <div className="relative">
          <Users className="h-5 w-5 text-[#1d4ed8]" />
          {connected && (
            <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-green-500 border-2 border-white" />
          )}
        </div>
        <div>
          <p className="text-sm font-medium" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {count} {count === 1 ? 'member' : 'members'} online
          </p>
          <p className="text-xs text-[#475569]">
            {connected ? 'Real-time sync active' : 'Connecting...'}
          </p>
        </div>
        {count > 0 && (
          <div className="ml-auto flex -space-x-2">
            {onlineUsers.slice(0, 5).map((uid, i) => (
              <div
                key={uid}
                className="h-7 w-7 rounded-full bg-[#1d4ed8] flex items-center justify-center text-white text-xs font-bold border-2 border-white"
                title={uid}
                data-testid={`online-avatar-${i}`}
              >
                {uid.charAt(0).toUpperCase()}
              </div>
            ))}
            {count > 5 && (
              <div className="h-7 w-7 rounded-full bg-[#475569] flex items-center justify-center text-white text-xs font-bold border-2 border-white">
                +{count - 5}
              </div>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};
